<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import * as _ from 'lodash'

export default {
  name: 'App',
  mounted() {
    const dtEnvironments = [
      { env: 'development', src: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf08103qjn/a9f2f26eff88f38b_complete.js' },
      { env: 'uat', src: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf08103qjn/80579e9d8b1fbc75_complete.js' },
      { env: 'production', src: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf08103qjn/d9af22a607ca3018_complete.js' }
    ]

    const dtConfig = _.find(dtEnvironments, { env: process.env.BUILD_ENV })
    if (dtConfig) {
      const dynatraceScript = document.createElement('script')
      dynatraceScript.type = 'text/javascript'
      dynatraceScript.src = dtConfig.src
      dynatraceScript.crossOrigin = 'anonymous'
      document.body.appendChild(dynatraceScript)
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Manrope&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Arvo&display=swap');
@import '../static/global.scss';

#app {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Manrope',
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f9faff;
}
.theme--light.v-input--is-disabled .v-label,
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #6b6b6b !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue